<template>

  <el-dropdown size="small" class="d2-mr">
    <span class="btn-text">你好 {{info.name}}</span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item @click.native="editInfoClick">
        <i class="fa fa-pencil fa-fw"></i>
          修改个人信息
        <div>
          <el-dialog title="修改信息" :visible.sync="editDialogForm" :before-close="newEditDialogClose"  :append-to-body='true'>
              <el-form ref="editForm" :rules="rules" :model="user">
                  <el-input v-model="user.id" v-show='false'></el-input>
                   
                    <el-form-item label="姓名" :label-width="formLabelWidth"  prop="nickName">
                        <el-input v-model="user.nickName" autocomplete="off"></el-input>
                    </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                  <el-button @click="newEditDialogClose">取 消</el-button>
                  <el-button type="primary" @click="onEditSubmit()">确 定</el-button>
              </div>
          </el-dialog>
        </div>
      </el-dropdown-item>
      <el-dropdown-item @click.native="changePassClick">
       <i class="fa fa-key fa-fw"></i>
        修改密码
        <div>
   <el-dialog title="修改密码" :visible.sync="changePassDialogForm" :before-close="newDialogClose"  :append-to-body='true'>
                <el-form ref="changePassForm" :rules="rules" :model="changePassPa">
                    <el-form-item label="原密码" :label-width="formLabelWidth" prop="pass">
                        <el-input type="password" v-model="changePassPa.pass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" :label-width="formLabelWidth" prop="newPass">
                        <el-input type="password" v-model="changePassPa.newPass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="确认新密码" :label-width="formLabelWidth" prop="checkNewPass">
                        <el-input type="password" v-model="changePassPa.checkNewPass" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="newDialogClose">取 消</el-button>
                    <el-button type="primary" @click="onSubmit()">确 定</el-button>
                </div>
            </el-dialog>
            </div>
      </el-dropdown-item>
      <el-dropdown-item @click.native="logOff">
        <d2-icon name="power-off" class="d2-mr-5"/>
        注销
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>

  
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
    data () {
        var validatePass = (rule, value, callback) => {
        if (value === ''||value==undefined) {
          callback(new Error('请输入新密码'));
        } else {
            if(value.length<6||value.length>18){
                callback(new Error('长度在6到18个字符'));
            }else{
                if (this.changePassPa.checkNewPass !== '') {
                this.$refs.changePassForm.validateField('checkNewPass');
                }
                 callback();
            }
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === ''||value==undefined) {
          callback(new Error('请再次输入新密码'));
        } else if (value !== this.changePassPa.newPass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
        return {
            rules:{
                pass: [
                    { required: true, message: '请输入原密码', trigger: 'blur' }
                ], 
                 newPass: [
                    { required: true,validator: validatePass, trigger: 'blur' }
                ],
                checkNewPass: [
                    { required: true,validator: validatePass2, trigger: 'blur' }
                ],
                nickName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { min: 0, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
                ]
            },
            changePassDialogForm:false,
            formLabelWidth: '120px',
            changePassPa:{
              pass:'',
              newPass: '',
              checkNewPass: ''
            },
            loading:'',
            editDialogForm:false,
            user:{
                nickName:'',
                login:'',
                state:'0'
            }
        }
    },
  computed: {
    ...mapState('d2admin/user', [
      'info'
    ])
  },
  methods: {
    ...mapActions('d2admin/account', [
      'logout',
      'changePass',
      'findMyInfo',
      'updateUser'
    ]),
     ...mapActions('d2admin/page', [
      'closeAll'
    ]),
    /**
     * @description 登出
     */
    logOff () {
      this.logout({
        vm: this,
        confirm: true
      })
    },
    /**
     * 修改密码
     */
    changePassClick(){
        this.changePassDialogForm=true
    },
    /**
     * 关闭对话框
     */
    newDialogClose(){
     
      this.changePassPa={}
      this.changePassDialogForm=false
    },
    /**
     * 提交密码修改
     */
    onSubmit(){
      this.$refs.changePassForm.validate((valid) => {
        if (valid) {
          this.loading=this.$loading({
              fullscreen:true,
              text:'加载中',
              background:"rgba(0, 0, 0, 0.6)"
          })
          this.changePass({
            vm: this,
            data:this.changePassPa
          
          })
        } else {
        // this.$message.error('表单校验失败')
        }
      });
    },
    editInfoClick(){
      this.findMyInfo({
            vm: this
      })
    },
    newEditDialogClose(){
      this.editDialogForm=false
    },
    onEditSubmit(){
       this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loading=this.$loading({
              fullscreen:true,
              text:'加载中',
              background:"rgba(0, 0, 0, 0.6)"
          })
          this.updateUser({
              vm: this,
              user:this.user
          }) 
       } else {
        // this.$message.error('表单校验失败')
        }
      });
    }
  }
}
</script>
